/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Spacing } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledRegularListItem = styled.li`
  margin-bottom: ${Spacing.Tiny}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledRegularListItem/index.js